import {useLayoutEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';

import {HOME_ROUTE} from '../../../../routes';
import {useAuthContext} from '../../../contexts/auth';

function isAdminPath(path) {
	return path?.match(/^\/?(dashboard|admin)/);
}

function resolveRedirection(user, location) {
	if (user.redirect) {
		return user.redirect;
	}

	const {search, hash} = location;
	const {redirectAfterLogin} = queryparse(search);

	const toAdmin = isAdminPath(redirectAfterLogin);
	const canRedirect = !toAdmin || (toAdmin && user.isAdmin);
	const destination = (canRedirect && redirectAfterLogin) || HOME_ROUTE;

	return `${destination}${hash}`;
}

function isCurrentLocation(location, destination) {
	const fullLocationPath = `${location.pathname}${location.search}`;
	return fullLocationPath === destination;
}

function useRedirectAfterLogin() {
	const {authUser} = useAuthContext();
	const navigate = useNavigate();
	const location = useLocation();

	useLayoutEffect(() => {
		if (authUser) {
			const destination = resolveRedirection(authUser, location);

			// Protect against circular navigation
			if (isCurrentLocation(location, destination)) {
				return;
			}

			if (isAdminPath(destination)) {
				// hard routing as /admin is not part of the hub router
				document.location.href = destination;
			} else {
				navigate(destination, {
					replace: true,
					state: {wasRedirected: true},
				});
			}
		}
	}, [authUser, navigate, location]);
}

export default useRedirectAfterLogin;
